import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { Card } from './Card';
import { GeneralText } from './GeneralText';
import { ReactComponent as AriaCondizionata } from '../media/aria_condizionata.svg';
import { ReactComponent as Riscaldamento } from '../media/riscaldamento.svg';
import { ReactComponent as Cartongesso } from '../media/cartongesso.svg';
import { ReactComponent as ImpiantiElettrici } from '../media/elettricisti.svg';
import { ReactComponent as Infissi } from '../media/finestre_e_porte_finestre.svg';
import { ReactComponent as Zanzariere } from '../media/zanzariere_zanzara.svg';
import { ReactComponent as Tinteggiature } from '../media/imbiancare.svg';
import { ReactComponent as ServiziEdili } from '../media/muratori.svg';
import { ReactComponent as Porte } from '../media/porte.svg';
import { ReactComponent as ParetiDivisorie } from '../media/pareti_divisorie.svg';
import { ReactComponent as Pavimenti } from '../media/posa_pavimenti.svg';
import { ReactComponent as Bagni } from '../media/ristrutturazione_bagni.svg';
import { ReactComponent as Chiavi } from '../media/ristrutturazione_casa_chiavi.svg';
import { ReactComponent as Uffici } from '../media/ristrutturazione_uffici_sedia.svg';
import { ReactComponent as Macerie } from '../media/smaltimento_macerie_camion.svg';
import { AnchorHTMLAttributes } from 'react';


const icons = [
  { name: "Ristrutturazione chiavi in mano", icon: <Chiavi />, href: "nav/house" },
  { name: "Riscaldamento", icon: <Riscaldamento />, href: "" },
  { name: "Condizionamento", icon: <AriaCondizionata />, href: "nav/air-conditioning" },
  { name: "Cartongesso", icon: <Cartongesso />, href: "nav/drywall" },
  { name: "Impianti elettrici", icon: <ImpiantiElettrici />, href: "" },
  { name: "Infissi", icon: <Infissi />, href: "" },
  { name: "Zanzariere", icon: <Zanzariere />, href: "" },
  { name: "Tinteggiature interne ed esterne", icon: <Tinteggiature />, href: "nav/painting" },
  { name: "Servizi edili", icon: <ServiziEdili />, href: "" },
  { name: "Porte blindate e porte interne", icon: <Porte />, href: "nav/doors" },
  { name: "Posa pavimenti", icon: <Pavimenti />, href: "nav/floor" },
  { name: "Impianti idraulici", icon: <Bagni />, href: "nav/bath" },
  { name: "Arredo ufficio", icon: <Uffici />, href: "nav/office-renovation" },
  { name: "Pareti divisorie uffici", icon: <ParetiDivisorie />, href: "nav/office" },
  { name: "Smaltimento macerie", icon: <Macerie />, href: "" },
]

export default function IconsCard() {
  const { t } = useTranslation(namespaces.common);

  return (
    <Card
      title={t("Cosa offriamo")}
      subtitle=""
      id={t("nav/services")}
    >
      <FlexContainer>
        {
          icons.map((item, i) => <IconWrapper
            key={i}
            as={item.href ? "a" : "div"}
            href={`#${t(item.href)}`}
          >
            <IconContainer>{item.icon}</IconContainer>
            <SmallText>{t(item.name)}</SmallText>
          </IconWrapper>)
        }
      </FlexContainer>
    </Card>
  )
}

const FlexContainer = styled.div`
  display: grid;
  gap: var(--gap);
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  grid-auto-rows: 1fr;
  align-items: baseline;
  justify-items: center;

  @media (max-width: 900px) {
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  }
`;
const IconWrapper = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  width: 130px;
  height: 100%;
  text-align: center;
  background: none;
  text-decoration: none;
  color: black;

  @media (max-width: 450px) {
    width: 60px;
  }
`;
const SmallText = styled(GeneralText)`
  font-size: 0.9rem;
  display: revert;

  @media (max-width: 450px) {
    display: none;
  }
`;
const IconContainer = styled.div`
    max-width: 90px;
    margin: auto;
`;